// extracted by mini-css-extract-plugin
export var arrow = "_22-4";
export var arrowButton = "_22-6";
export var columnResizer = "_22-a";
export var columnResizerActive = "_22-b";
export var columnResizerIndicator = "_22-c";
export var columnResizerIndicatorActive = "_22-d";
export var headerCell = "_22-0";
export var help = "_22-3";
export var hoverArrow = "_22-5";
export var icon = "_22-2";
export var iconButton = "_22-9";
export var iconWrapper = "_22-8";
export var noBorder = "_22-e";
export var sortableHeaderCell = "_22-1";
export var textButton = "_22-7";